/**
 * The palette a new tag can take. Tags store their colour as a hex value in the database
 * (the labels table), so this is data rather than styling — which is why it lives outside
 * the feature and component trees, where raw hex is forbidden by lint.
 *
 * Brand blue, violet, green, then the status tones and a neutral.
 */
export const TAG_COLORS = [
  '#2f5bf6',
  '#6d3df5',
  '#0a9a7a',
  '#c77700',
  '#d5382f',
  '#0a7ea4',
  '#db2777',
  '#64748b',
] as const
